export default {
    setModal: (state, action) => {
        const actionType = action.type;
        const stateModalName = 'elementsModal';
        const elementsModalOpen = !!state[stateModalName].location;
        if (actionType === 'canvasBlocksTypes/SWITCH_LOCK_STRUCTURE') {
            if (elementsModalOpen && action.payload.blockIdx === state.elementsModal.location.blockIndex) {
                const modal = { status: false, location: null };
                state[stateModalName] = modal;
            }
        } else if (actionType === 'canvasBlocksTypes/LOCK_BLOCKS') {
            const modal = { status: false, location: null };
            state[stateModalName] = modal;
        } else {
            const { name, status, location } = action.payload;
            const modal = { status, location };
            state[name] = modal;
        }
    },
};
